import type { Task, Item } from "~/types/api";

export const SortBy = {
  Name: "name",
  Workflow: "workflow",
} as const;

export const Direction = {
  Left: "left",
  Right: "right",
} as const;

export type DirectionType = (typeof Direction)[keyof typeof Direction];
export type SortType = (typeof SortBy)[keyof typeof SortBy];

export type TaskWithItems = Task & {
  items?: Item[];
};

export type StatusGroup = {
  id: number;
  name: string;
  children: Item[];
};

export type ExplorerItem = TaskWithItems | StatusGroup | Item;

export type AddWindowProps = {
  taskIds?: number[];
  subtitle?: string;
  appliedListIds?: number[];
};

export type TabWindowState = AddWindowProps & {
  id: string;
  title: string;
  isOpen: boolean;
  isMinimized: boolean;
  isPinned: boolean;
  order: number;
  sortType?: SortType;
  selectedItems?: Set<number>;
};

export type TabWindow<T = ExplorerItem> = {
  id: string;
  state: TabWindowState;
  items: T[];
  originalItems?: T[];
};

export type PinnedTabWindowsState = {
  windows: TabWindowState[];
  nextOrder: number;
};
